import { FETCH_SHIP_TO, FETCH_SHIP_TO_FULFILLED, FETCH_SHIP_TO_REJECTED } from '../actions'

export default (state = {
  data: null,
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  switch (action.type) {
    case FETCH_SHIP_TO:
      return { ...state, fetching: true, fetched: false, error: null }
    case FETCH_SHIP_TO_FULFILLED:
      const payload = action.payload
      return { ...state, fetching: false, fetched: true, error: null, data: payload }
    case FETCH_SHIP_TO_REJECTED:
      return { ...state, fetching: false, fetched: false, error: action.payload, data: null }

    default:
      return state
  }
}
